// extracted by mini-css-extract-plugin
module.exports = {"appointment-form-page__row":"_3M-UD1f76YqEdzAKlRC8aI","appointment-form-page__aside":"VmOonvqiSpV6Rf6k9euRZ","appointment-form-page__main":"_5QC2pcgivwyaxpNq7jbn4"};